import { FEATURE_NAME } from './consts';

export const SYNCHRONIZE = `${FEATURE_NAME}/SYNCHRONIZE`;
